// extracted by mini-css-extract-plugin
export default {"grid":"AnswerGrid_grid__FBVeB"};